import store from '@/state/store';
import { getLogo } from '@/api/project';
import { handleError } from '@/actions/common';
import projectSlice from '@/state/project.slice';
import { RequestStatus } from '@/contracts';
import { ApiError } from '@bimdata/client';

export default async function ({ code, logo }: { code: string, logo: number | null }): Promise<void> {
  if (!logo) {
    store.dispatch(projectSlice.actions.logoIdle({
      projectId: code,
      source: null
    }));
    return;
  }

  const state = store.getState();
  if (state.projects.logos[code]?.status === RequestStatus.BUSY) {
    return;
  }

  try {
    store.dispatch(projectSlice.actions.logoBusy(code));
    const source = await getLogo(code, logo);
    store.dispatch(projectSlice.actions.logoIdle({
      projectId: code,
      source
    }));
  } catch (error) {
    if (error instanceof ApiError && error.code === 403) {
      store.dispatch(projectSlice.actions.logoIdle({
        projectId: code,
        source: null
      }));
      return;
    }

    store.dispatch(projectSlice.actions.logoError(code));
    handleError(error);
  }
};